import _ from 'lodash';
import lineLimiting from './line-limiting';

function maintainElementLineCount($el, lineCount) {
  const inner = () => lineLimiting(lineCount)($el);

  $(window).on('resize', _.throttle(() => inner(), 100));
  setTimeout(() => inner(), 100);
}

/*
This allows limiting the number of lines in a simple element containing plain
text using a data attribute (no code). For example:

    <p id="my_paragraph" data-line-limit="2">...</p>
*/
export default function bootstrap() {
  $('[data-line-limit]').each((i, el) => {
    const $el = $(el);
    const lineLimit = parseInt($el.data('line-limit'), 10);

    maintainElementLineCount($el, lineLimit);
  });
}
